export class MockDialogService {
  openConfirmDialog = jasmine.createSpy('openConfirmDialog');
  openPromptDialog = jasmine.createSpy('openPromptDialog');
  openClassicDialog = jasmine.createSpy('openClassicDialog');
  openDialog = jasmine.createSpy('openDialog');
}
